import React from 'react';
import { Records } from './Records';

const Form = () => (
  <div className="container mt-4">
    <h4 className="display-4 text-center mb-4">
      <i className="fas fa-clipboard-list"></i> Formularios
    </h4>
    <Records />
  </div>
);

export default Form;